import { createBrowserClient } from '@supabase/ssr'

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!

// Guard: clear stale localStorage sessions left by legacy @supabase/auth-helpers-nextjs
// or a previous sign-in. When localStorage has a session for a DIFFERENT user than the
// current cookie session (set by SSR middleware on login), the Supabase JS client sends
// the wrong Bearer token for REST calls, causing RLS UPDATE checks to silently return
// 0 rows while still showing a "saved" toast (no error, just wrong user context).
if (typeof window !== 'undefined') {
  try {
    const ref = new URL(supabaseUrl).hostname.split('.')[0]
    const lsKey = `sb-${ref}-auth-token`
    const lsRaw = localStorage.getItem(lsKey)
    if (lsRaw) {
      // Parse localStorage session to get user sub
      const lsSub: string | null = (() => {
        try {
          const j = JSON.parse(lsRaw)
          const parts = (j.access_token || '').split('.')
          return JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))).sub
        } catch { return null }
      })()

      // Parse cookie session to get user sub
      const cookieRaw = document.cookie.split(';').find(c => c.trim().startsWith(`${lsKey}=`))
      const cookieSub: string | null = (() => {
        try {
          const val = cookieRaw!.trim().slice(`${lsKey}=`.length)
          const json = JSON.parse(atob(val.replace('base64-', '')))
          const parts = (json.access_token || '').split('.')
          return JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))).sub
        } catch { return null }
      })()

      // If both exist and they disagree, or localStorage has an orphaned session, clear it
      if (lsSub && cookieSub && lsSub !== cookieSub) {
        localStorage.removeItem(lsKey)
      } else if (lsSub && !cookieSub) {
        localStorage.removeItem(lsKey)
      }
    }
  } catch {
    // best-effort — never break app startup
  }
}

export const supabase = createBrowserClient(supabaseUrl, supabaseAnonKey)
